/**
 * The standard In Development tile for a client-portal page that is in the navigation but not built yet (#12311,
 * the phase-manifest render; DL-X-30 D3). Mirrors the markup of the shared `@babomrs/ui` InDevelopmentPlaceholder,
 * named by RELEASE rather than phase because the client prototype names releases (R05, R11).
 *
 * Shows the page title, an amber "In Development — {release}" pill and one line — never a count and never client
 * data, so it cannot assert anything about the person's records (BR-CP-HOME-001).
 */
export interface InDevelopmentTileProps {
  /** The page's own title, e.g. "My companies". */
  title: string;
  /** The release the page ships in, e.g. "R11". */
  release: string;
}

export function InDevelopmentTile({ title, release }: InDevelopmentTileProps) {
  return (
    <div
      role="status"
      className="flex flex-col items-center justify-center rounded-lg border border-[var(--border)] bg-[var(--surface)] p-8 text-center"
    >
      <span className="inline-flex items-center gap-1.5 rounded-full border border-amber-300 bg-amber-100 px-3 py-1 text-xs font-medium text-amber-700">
        <span className="h-1.5 w-1.5 rounded-full bg-amber-500" aria-hidden="true" />
        In Development — {release}
      </span>
      <h1 className="mt-4 text-lg font-semibold text-[var(--text1)]">{title}</h1>
      <p className="mt-2 max-w-sm text-sm text-[var(--text2)]">
        This page is planned for release {release} and is not available yet. It will appear here once it has been
        delivered.
      </p>
    </div>
  );
}
